<!--
  ProfileDialog.vue
    Profile Setting Dialog Component
-->

<!-- -------------------------------------------------------------------------------- -->
<template>
  <v-dialog
    v-model="mDialog"
    fullscreen
    hide-overlay
    transition="slide-x-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card dark color="primary" app class="hm-iphonex-notch">
        <v-btn icon color="primary" @click="onClickClose">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ $t("settings.profile") }}</v-toolbar-title>
      </v-toolbar>

      <v-card-text
       id="hm-pd-container"
       class="hm-pd-container"
      >
      <div class="hm-iphonex-notch">
        <div class="hm-pd-content">
          <div class="hm-pd-username">
            {{ mLoginUserInfo.name }}
          </div>

          <v-divider />

          <div class="hm-pd-org">
            {{ mSectionName }}
          </div>
          <div class="hm-pd-org">
            {{ mGroupName }}
          </div>

          <v-divider />

          <div
            class="hm-pd-fileselect"
            @dragleave.prevent="onDragLeave"
            @dragover.prevent="onDragOver"
            @drop.prevent="onFileSelected"
          >
            <div>
            <div :class="{'hm-hide': !isAvatarAvailable}">
              <v-avatar :size="mAvatarSize" @click="onClickSelectAvatar">
                <img :src="this.mAvatarImg">
              </v-avatar>
            </div>
            <div :class="{'hm-hide': isAvatarAvailable}">
              <v-avatar :size="this.mAvatarSize" color="grey lighten-1" @click="onClickSelectAvatar">
                <v-icon :size="48" color="grey lighten-4">person</v-icon>
              </v-avatar>
            </div>
            </div>

            <!--
            <v-avatar :size="mAvatarSize">
              <img :src="mAvatarImg">
            </v-avatar>
            -->

            <input type="file" accept="image/*" ref="avatarSelect" style="display: none;" @change="onFileSelected">

          </div>

          <div>
          <span class="hm-display-mobile">
          画像をタップして変更できます<br>
          </span>
          <span class="hm-display-monitor">
          画像をクリックして変更できます<br>
          </span>
          「画像を確定」で確定します
          </div>

          <div class="hm-pd-btns">
            <v-btn
              color="primary"
              class="white--text"
              @click="onClickSendAvatar"
            >
              画像を確定
            </v-btn>
            <v-btn
              color="secondary"
              class="white--text"
              @click="onClickDeleteAvatar"
            >
              画像を削除
            </v-btn>
          </div>

          <v-divider />

        </div>
      </div>
      </v-card-text>
    </v-card>

    <info-dialog ref="infoDialog">
      <div slot="msg">画像を更新しました</div>
    </info-dialog>
    <info-dialog-delete ref="infoDialogDelete">
      <div slot="msg">画像を削除しました</div>
    </info-dialog-delete>
    <info-dialog-noavatar ref="infoDialogNoAvatar">
      <div slot="msg">画像が設定されていません</div>
    </info-dialog-noavatar>
    <error-dialog ref="errorDialog">
      <div slot="msg">画像の保存に失敗しました</div>
    </error-dialog>
    <error-dialog-delete ref="errorDialogDelete">
      <div slot="msg">画像の削除に失敗しました</div>
    </error-dialog-delete>
    <error-dialog-fileread ref="errorDialogFileRead">
      <div slot="msg">画像の読み込みに失敗しました</div>
    </error-dialog-fileread>
    <error-dialog-fileimg ref="errorDialogFileImg">
      <div slot="msg">画像ファイルを選択してください</div>
    </error-dialog-fileimg>
    <confirm-dialog ref="confirmDialog">
      <div slot="msg">{{ mConfirmMsg }}</div>
    </confirm-dialog>

  </v-dialog>
</template>

<script src="@/lib/load_image/load-image.all.min.js"></script>

<!-- -------------------------------------------------------------------------------- -->
<script>
import { isNullorUndefined } from '@/common'
import ErrorDialog from '@/components/dialogs/ErrorInfoDialog'
import InfoDialog from '@/components/dialogs/SystemInfoDialog'
import ConfirmDialog from '@/components/dialogs/ConfirmDialog'

export default {
  name: 'ProfileDialog',
  data: () => ({
    mDialog: false,
    mLoginUserInfo: {},
    mAvatarFile: null,
    mAvatarFileCanvas: null,
    mAvatarUrl: '',
    mAvatarSize: 84,
    mAvatarImg: null,
    mSectionName: '',
    mGroupName: '',
    mConfirmMsg: '',
  }),
  components: {
    'error-dialog': ErrorDialog,
    'error-dialog-delete': ErrorDialog,
    'error-dialog-fileread': ErrorDialog,
    'error-dialog-fileimg': ErrorDialog,
    'confirm-dialog': ConfirmDialog,
    'info-dialog': InfoDialog,
    'info-dialog-delete': InfoDialog,
    'info-dialog-noavatar': InfoDialog,
  },
  mounted: function () {
    this.$log.debug('# ProfileDialog')
    this.$on('showProfile', this.show)
  },
  destroyed: function () {
    this.$log.debug('# ProfileDialog.')
  },
  computed: {
    // -------------------------------------------------------------------------
    isAvatarAvailable: function () {
      return (!isNullorUndefined(this.mAvatarImg) && (this.mAvatarImg !== ''))
    },
  },
  methods: {
    // -------------------------------------------------------------------------
    show: function () {
      this.$store.commit('setIsWhereaboutsPage', false)   // 行動予定一覧の更新を行わない
      this.mDialog = true  // Show Dialog
      this.mLoginUserInfo = this.$store.getters.loginUserBaseInfo
      this.mAvatarFile = null
      if (!isNullorUndefined(this.mLoginUserInfo.avatar) && (this.mLoginUserInfo.avatar !== '')) {
        this.mAvatarImg = this.mLoginUserInfo.avatar + '?' + Date.now() + 'i'
      }
      this.mSectionName = this.$store.getters.fSection(this.mLoginUserInfo.section_id)[0].s_name
      this.mGroupName = this.$store.getters.fGroup(this.mLoginUserInfo.group_id)[0].g_name
      this.$nextTick(() => {
        // DOM生成完了後に実行
        document.getElementById('hm-pd-container').scrollTop = 0
      })
    },
    onClickClose: function () {
      this.$store.commit('setIsWhereaboutsPage', true)   // 行動予定一覧の更新を行う
      this.mDialog = false
    },
    // -------------------------------------------------------------------------
    onFileSelected: function (e) {
      let files = e.target.files || e.dataTransfer.files
      this.$log.debug(files[0])

      // 画像判定
      if (!/image/.test(files[0].type)) {
        this.$refs.errorDialogFileImg.$emit('show')
        return
      }

      // 選択した画像を表示
      if (!isNullorUndefined(files[0])) {
        this.mAvatarFile = files[0]
        /*
        let reader = new FileReader()
        reader.onload = (e) => {
          //this.mAvatarImg = e.target.result
          this.mAvatarImg = reader.result
          // ファイルを加工して送信する
          //this.adjustImage(this.mAvatarImg)
        }
        reader.readAsDataURL(this.mAvatarFile)
        */
        this.loadImageByLib(this.mAvatarFile)
      }
      else {
        this.$refs.errorDialogFileRead.$emit('show')
      }
    },
    // -------------------------------------------------------------------------
    adjustImage: function (imageFile) {
      const TRIM_SIZE = 72
      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')
      canvas.height = TRIM_SIZE
      canvas.width = TRIM_SIZE
      canvas.id = 'avatar-img'  // ダミーのcanvas id

      let image = new Image()
      image.src = imageFile

      image.onload = () => {
        let image_size = { width: image.naturalWidth, height: image.naturalHeight }

        // 正方形にトリミング
        let offset_x = 0
        let offset_y = 0
        let height = 0
        let width = 0
        if (image_size.width > image_size.height) {
          height = TRIM_SIZE
          width = image_size.width * (TRIM_SIZE / image_size.height)
          offset_x = -(width - TRIM_SIZE) / 2
        }
        else {
          width = TRIM_SIZE
          height = image_size.height * (TRIM_SIZE / image_size.width)
          offset_y = -(height - TRIM_SIZE) / 2
        }

        context.drawImage(image, offset_x, offset_y, width, height)

        this.mAvatarImg = canvas.toDataURL(this.mAvatarFile.type)

        // IE, EdgeではtoBlobが使えない
        if (canvas.toBlob) {
          canvas.toBlob((blob) => {
            this.mAvatarFileCanvas = new File(
              [blob],
              this.mAvatarFile.name,
              {
                type: this.mAvatarFile.type,
                lastModified: Date.now(),
              })
          })
        }
        else if (canvas.msToBlob) {
          let blob = canvas.msToBlob()
          // Fileコンストラクタが使えないのでblobで代用する
          this.mAvatarFileCanvas = new Blob(
            [blob],
            {
              type: this.mAvatarFile.type,
            }
          )
          this.mAvatarFileCanvas.lastModified = Date.now()
          this.mAvatarFileCanvas.name = this.mAvatarFile.name
        }
        else {
          let bin = atob(this.mAvatarImg.replace(/^.*,/, ''))
          let buffer = new Uint8Array(bin.length)
          for (let i = 0; i < bin.length; i++) {
            buffer[i] = bin.charCodeAt(i)
          }
          this.mAvatarFileCanvas = new File(
            [buffer.buffer],
            this.mAvatarFile.name,
            {
              type: this.mAvatarFile.type,
              lastModified: Date.now(),
            })
        }
      }
    },
    // -------------------------------------------------------------------------
    loadImageByLib: function (imageFile) {
      const TRIM_SIZE = 72

      loadImage.parseMetaData(imageFile, (data) => {
        let options = {
          maxHeight: TRIM_SIZE,
          maxWidth: TRIM_SIZE,
          crop: true,
          canvas: true,
        }

        if (data.exif) {
          options.orientation = data.exif.get('Orientation')
        }

        loadImage(imageFile, (canvas) => {
          this.mAvatarImg = canvas.toDataURL(this.mAvatarFile.type)
          this.createUploadImage(canvas)
        }, options)
      })
    },
    // -------------------------------------------------------------------------
    createUploadImage: function (canvas) {
      // IE, EdgeではtoBlobが使えない
      if (canvas.toBlob) {
        canvas.toBlob((blob) => {
          this.mAvatarFileCanvas = new File(
            [blob],
            this.mAvatarFile.name,
            {
              type: this.mAvatarFile.type,
              lastModified: Date.now(),
            })
        })
      }
      else if (canvas.msToBlob) {
        let blob = canvas.msToBlob()
        // Fileコンストラクタが使えないのでblobで代用する
        this.mAvatarFileCanvas = new Blob(
          [blob],
          {
            type: this.mAvatarFile.type,
          }
        )
        this.mAvatarFileCanvas.lastModified = Date.now()
        this.mAvatarFileCanvas.name = this.mAvatarFile.name
      }
      else {
        let bin = atob(this.mAvatarImg.replace(/^.*,/, ''))
        let buffer = new Uint8Array(bin.length)
        for (let i = 0; i < bin.length; i++) {
          buffer[i] = bin.charCodeAt(i)
        }
        this.mAvatarFileCanvas = new File(
          [buffer.buffer],
          this.mAvatarFile.name,
          {
            type: this.mAvatarFile.type,
            lastModified: Date.now(),
          })
      }
    },
    // -------------------------------------------------------------------------
    onDragOver: function (e) {
      this.$log.debug('drag over')
    },
    // -------------------------------------------------------------------------
    onDragLeave: function (e) {
      this.$log.debug('drag leave')
    },
    // -------------------------------------------------------------------------
    onClickSelectAvatar: async function () {
      this.$refs.avatarSelect.click()
    },
    // -------------------------------------------------------------------------
    onClickSendAvatar: async function () {
      if (isNullorUndefined(this.mAvatarFile)) {
        return
      }

      let form_data = new FormData()
      this.$log.debug(form_data)
      form_data.append('avatar-img', this.mAvatarFileCanvas)
      this.$log.debug(form_data)

      const result = await this.$store.dispatch(
        'aUploadAvatar',
        {
          company_id: this.$store.getters.loginUserCompanyId,
          user_id: this.$store.getters.loginUserId,
          form_data: form_data
        }
      )
      if (!result.error && !result.body.error) {
        //this.mAvatarUrl = result.body + '?' + Date.now()
        this.$refs.infoDialog.$emit('show')
      }
      else {
        this.$refs.errorDialog.$emit('show')
      }
    },
    // -------------------------------------------------------------------------
    onClickDeleteAvatar: async function () {
      if (!this.isAvatarAvailable) {
        this.$refs.infoDialogNoAvatar.$emit('show')
      }
      else {
        this.mConfirmMsg = '画像を削除します'
        this.$refs.confirmDialog.$emit('show', this.doDeleteAvatar)
      }
    },
    // -------------------------------------------------------------------------
    doDeleteAvatar: async function () {
      const result = await this.$store.dispatch(
        'aDeleteAvatar',
        {
          company_id: this.$store.getters.loginUserCompanyId,
          user_id: this.$store.getters.loginUserId,
        }
      )
      if (!result.error && !result.body.error) {
        //this.mAvatarUrl = result.body + '?' + Date.now()
        this.$refs.infoDialogDelete.$emit('show')
        this.mAvatarFile = null
        this.mAvatarImg = null
      }
      else {
        this.$refs.errorDialogDelete.$emit('show')
      }
    },
  }
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
.hm-pd-container {
  margin-top: 56px;
}
@media screen and (min-width: 601px) {
  /* 幅601px～ */
  .hm-pd-container {
    width: calc(100vw - 17px);
  }
}
.hm-pd-content {
  width: 60vw;
  margin: 0 auto;
  margin-top: 10px;
  text-align: center;
  /*border: solid 1px #8b0000;*/
}
.hm-pd-username {
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: bold;
}
@media screen and (min-width: 601px) {
  /* 幅601px～ */
  .hm-pd-username {
    font-size: 24px;
    font-weight: bold;
  }
}
.hm-pd-org {
  font-size: 14px;
  font-weight: bold;
}
@media screen and (min-width: 601px) {
  /* 幅601px～ */
  .hm-pd-org {
    font-size: 20px;
    font-weight: bold;
  }
}
.hm-pd-fileselect {
  margin: 0 auto;
  margin-top: 70px;
  height: 100px;
  text-align: center;
  /*border: solid 1px;*/
}
.hm-pd-btns {
  margin-top: 50px;
  margin-bottom: 10px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/dialogs/ProfileDialog.vue